<div class="container">

    <section>
        <div class="row">
            <div class="col-md-8 col-md-offset-2">
                <h1>Iniciar tramite</h1>
                <hr>
                <form autocomplete="off" [formGroup]="forInicioTramite" (ngSubmit)="onSubmit()">

                    <!-- ARCHIVO -->
                    <fieldset>
                        <legend>
                            <h3 class="m-b-1">Cargar Archivo <i *ngIf="pdfConfirmado" id="fa fa-check-square-o"
                                    class="fa fa-check-square-o icono-3x"></i></h3>
                        </legend>
                        <div class="row">
                            <div class="col-md-12 form-group item-form"
                                [ngClass]="{ 'has-error': formEnviado && formulario.archivo.errors }">
                                <label for="pdfPath">Archivo</label>

                                <div class="row">
                                    <div class="col-md-8">
                                        <input type="text" disabled class="form-control" id="pdfPath" required=""
                                            name="pdfPath" aria-required="true" value='{{pathPdf}}'>
                                    </div>
                                    <input class="hidden" name="archivo" accept="application/pdf" type="file"
                                        (change)="onFileSelect($event)" #hiddenfileinput formControlName="archivo">
                                    <div class="col-md-4">
                                        <button onclick="return false;" (click)="hiddenfileinput.click()"
                                            class="btn btn-primary btn-block">
                                            Examinar </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="mostrarPdf">
                            <a class="panel panel-default panel-icon panel-secondary">
                                  <div class="panel-heading icon-fix"><i class="fa fa-file"></i></div>
                                  <div class="panel-body">
                                        <ngx-extended-pdf-viewer *ngIf="mostrarPdf" [enablePrint]="false"
                                        [hidden]="!pdfData" [base64Src]="pdfData" [textLayer]="true"
                                        backgroundColor="#f2f2f2" [delayFirstView]="1000" [height]="'60vh'"
                                        [useBrowserLocale]="false" language="es" [handTool]="true" [zoom]="'page-width'"
                                        [showBorders]="true" [showZoomButtons]="true" [showRotateButton]="true"
                                        [showToolbar]="true" [enableDragAndDrop]="false" [showDownloadButton]="false"
                                        [showBookmarkButton]="false" [showPresentationModeButton]="false"
                                        [showOpenFileButton]="false" [minifiedJSLibraries]="false"
                                        [showUnverifiedSignatures]="false">
                                    </ngx-extended-pdf-viewer>
                                      </div>
                            </a>
                        </div>
                    </fieldset>

                    <!-- DATOS PERSONALES -->
                    <fieldset>
                        <legend>
                            <h3>Datos personales <i *ngIf="forInicioTramite.valid" id="fa fa-check-square-o"
                                    class="fa fa-check-square-o icono-3x"></i></h3>
                        </legend>

                        <div class="row">

                            <div class="col-md-4">
                                <div class="form-group item-form"
                                    [ngClass]="{ 'has-error': formEnviado && formulario.idTipoDocumento.errors }">
                                    <label for="idTipoDocumento">Tipo de Documento</label>
                                    <select id="idTipoDocumento" name="idTipoDocumento" class="form-control"
                                        formControlName="idTipoDocumento">
                                        <option value="DNI">DNI</option>
                                        <option value="CI">Cédula de Identidad</option>
                                        <option value="LE">Libreta de Enrolamiento</option>
                                        <option value="LC">Libreta Cívica</option>
                                        <option value="CC">Cédula de Ciudadanía</option>
                                        <option value="PAS">Pasaporte</option>
                                    </select>
                                    <p *ngIf="formEnviado && formulario.idTipoDocumento.errors"
                                        class="help-block error text-danger">
                                        Elegí un tipo de documento</p>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group item-form"
                                    [ngClass]="{ 'has-error': formEnviado && formulario.numeroDocumento.errors }">
                                    <label for="numeroDocumento" id="mostrar-tipo">Número de documento</label>
                                    <input type="text" min="1" class="form-control" id="numeroDocumento"
                                        name="numeroDocumento" aria-required="true" formControlName="numeroDocumento">
                                    <p class="help-block error text-danger"
                                        *ngIf="formEnviado && formulario.numeroDocumento.errors?.required">Ingresá tu
                                        número
                                        de
                                        documento</p>
                                    <p class="help-block error text-danger"
                                        *ngIf="formEnviado && formulario.numeroDocumento.errors?.pattern">Ingresá un
                                        documento válido
                                    </p>
                                    <p class="help-block text-secondary">Sin guiones ni barras</p>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-12">
                                <fieldset>
                                    <legend>
                                        <label>Sexo</label>
                                        <p class="help-block text-secondary">Como aparece en tu DNI</p>
                                    </legend>
                                    <div class="form-group item-form">
                                        <label for="f" class="radio-inline">
                                            <input type="radio" name="sexo" id="f" value="F" aria-required="true"
                                                formControlName="sexo">
                                            Femenino
                                        </label>
                                        <label for="m" class="radio-inline">
                                            <input type="radio" name="sexo" id="m" value="M" aria-required="true"
                                                formControlName="sexo">
                                            Masculino
                                        </label>
                                        <p class="help-block error p-y-1 text-danger"
                                            *ngIf="formEnviado && formulario.sexo.errors?.required">Ingresá tu sexo
                                        </p>
                                    </div>
                                    <div id="errorCompletarForm"
                                        *ngIf="formEnviado && (forInicioTramite.invalid || !pdfConfirmado)"
                                        aria-live="polite" class="alert alert-danger">
                                        <h5>Error</h5>
                                        <li *ngIf="formEnviado && forInicioTramite.invalid">Completar datos</li>
                                        <li *ngIf="formEnviado && !pdfConfirmado">Confirmar PDF</li>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <button routerLink="/home" class="btn btn-link">Cancelar</button>
                                            <button type="submit" class="btn btn-success m-l-1"
                                                [ngClass]="{ 'state-loading': formEnviando && forInicioTramite.valid }">Enviar</button>
                                        </div>
                                    </div>
                                    <div *ngIf="error && formEnviado" aria-live="polite" class="alert alert-warning">
                                        <li>{{errorString}}</li>
                                    </div>

                                </fieldset>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </section>

</div>